"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.sortStatus = exports.sortProgramStatusPillBox = exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _lodash = _interopRequireDefault(require("lodash"));
var _pillBox = _interopRequireWildcard(require("../pillBox"));
var _sortUtil = _interopRequireDefault(require("../sortUtil"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
/**
 * getProgramStatus
 * @param  {Array} programDetails
 * @param  {Array || String} containerName
 * @return {Array}
 */
var getProgramStatus = function getProgramStatus(programDetails, containerName) {
  if (_lodash.default.isString(containerName)) {
    return _lodash.default.filter(programDetails, ['containerName', containerName]);
  }
  var listProgramStatus = [];
  _lodash.default.forEach(containerName, function (c) {
    return listProgramStatus.push(_lodash.default.filter(programDetails, ['containerName', c]));
  });
  return _lodash.default.flattenDeep(listProgramStatus) || [];
};

/**
 * Sort program status column
 * @param {Object} a The first value to compare
 * @param {Object} b The second value to compare
 * @param {String} order The type that you want to sort
 * @param {String} containerName
 * @return {Boolean} The result compare
 */
var sortProgramStatusPillBox = function sortProgramStatusPillBox(a, b, order, containerName) {
  var firstValue = getProgramStatus(a.programDetails, containerName);
  var secondValue = getProgramStatus(b.programDetails, containerName);
  return _sortUtil.default.compareNumber(firstValue.length, secondValue.length, order);
};

/**
 * Sort program status column
 * @param {Object} a The first value to compare
 * @param {Object} b The second value to compare
 * @param {String} order The type that you want to sort
 * @param {Object} option
 * @return {Boolean} The result compare
 */
exports.sortProgramStatusPillBox = sortProgramStatusPillBox;
var sortStatus = function sortStatus(a, b, order, option) {
  var v1;
  var v2;
  if (a.accountStatus || a.programStatus) {
    v1 = "".concat(a.accountStatus, " ").concat(a.programStatus);
  } else {
    v1 = 'N/A';
  }
  if (b.accountStatus || b.programStatus) {
    v2 = "".concat(b.accountStatus, " ").concat(b.programStatus);
  } else {
    v2 = 'N/A';
  }
  return _sortUtil.default.compareString(v1, v2, order, option);
};

/**
 * Get pillbox values
 * @param {Object} survey
 */
exports.sortStatus = sortStatus;
var getPillBoxValues = function getPillBoxValues(survey) {
  var badgeIconType = !_lodash.default.isNil(_pillBox.PROPERTY_BADGE_STATUS_ICON[survey.badgeStatusIcon]) ? _pillBox.PROPERTY_BADGE_STATUS_ICON[survey.badgeStatusIcon].type : _pillBox.PROPERTY_BADGE_STATUS_ICON.X_MARK.type;
  return {
    pillText: survey.pillText,
    iconType: badgeIconType,
    pillStatus: survey.pillStatus,
    tooltip: survey.tooltip
  };
};

/**
 * Render ProgramStatusPillBox
 * @param  {Object} props
 * @return {Element} React element
 */
var ProgramStatusPillBox = function ProgramStatusPillBox(props) {
  var data = props.data,
    containerName = props.containerName,
    t = props.t;
  var programDetails = data.programDetails;
  programDetails = getProgramStatus(programDetails, containerName);
  if (_lodash.default.isEmpty(programDetails)) {
    return /*#__PURE__*/_react.default.createElement("div", null, "N/A");
  }
  programDetails = _lodash.default.sortBy(programDetails, 'displayOrder');
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "list-pill-box-wrapper"
  }, _lodash.default.map(programDetails, function (survey, index) {
    var pillboxValues = getPillBoxValues(survey);
    return /*#__PURE__*/_react.default.createElement(_pillBox.default, {
      key: "".concat(data.participantId, "-").concat(data.prospectId, "-").concat(survey.containerItemId, "-").concat(index),
      text: _lodash.default.get(pillboxValues, 'pillText'),
      type: _lodash.default.get(pillboxValues, 'iconType'),
      status: _lodash.default.get(pillboxValues, 'pillStatus'),
      tooltip: _lodash.default.get(pillboxValues, 'tooltip'),
      className: "pill-box-wrapper",
      t: t
    });
  }));
};
ProgramStatusPillBox.propTypes = {
  data: _propTypes.default.shape({
    programDetails: _propTypes.default.arrayOf({}),
    participantId: _propTypes.default.number,
    prospectId: _propTypes.default.number
  }).isRequired,
  containerName: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.instanceOf([])]).isRequired,
  t: _propTypes.default.func
};
ProgramStatusPillBox.defaultProps = {
  t: function t(x) {
    return x;
  }
};
var _default = ProgramStatusPillBox;
exports.default = _default;